import {LOADER_HTML} from "../topbottom/utils";

export function setGlobalHighStockOptions(Highcharts) {
    const highStockOptions = {
        global: {
            //timezone: 'Europe/Madrid',
            useUTC: true
        },
        lang: {
            months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
            weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
            shortMonths: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
            downloadJPEG: "Descargar en imagen JPEG",
            downloadPDF: "Descargar en documento PDF",
            downloadPNG: "Descargar en imagen PNG",
            downloadSVG: "Descargar en imagen SVG",
            printChart: "Imprimir gráfica",
            decimalPoint: ',',
            thousandSep: '.'
        },
        watermark: {
            url: 'https://www.estrategiasdeinversion.com/images/logoEstrategiasDeInversion.gif',
            width: 233,
            height: 59,
            opacity: 0.1,
            top: false
        },

        credits: {
            enabled: true,
            text: 'Estrategias de Inversión',
            href: 'https://www.estrategiasdeinversion.com'
        }
    };
    Highcharts.setOptions(highStockOptions);
}

export function renderIntradayHighChart(response, Highcharts) {
    let color, fillColor;
    if (response.data.var > 0) {
        color = '#006400';
        fillColor = '#9be2bc';
    } else if (response.data.var < 0) {
        color = '#950000';
        fillColor = '#ffaca1';
    } else {
        color = '#999999';
        fillColor = '#cccccc';
    }

    const optionsintraday = {
        chart: {
            renderTo: response.chartId
        },
        navigator: {
            enabled: false
        },
        scrollbar: {
            enabled: false
        },
        rangeSelector: {
            enabled: false
        },
        //Desactivar hamburguesa
        navigation: {
            buttonOptions: {
                enabled: false
            }
        },
        yAxis: {
            opposite: false,
            plotLines: [{
                width: 2,
                color: '#555555',
                value: response.data.prevClose,
                dashStyle: 'shortdash'
            }]
        },
        tooltip: {
            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:,.3f}</b><br/>',
            valueDecimals: 3
        },
        loading: {
            hideDuration: 100,
            showDuration: 100,
            labelStyle: {
                fontWeight: 'bold',
                position: 'relative',
                top: '45%'
            }
        },
        series: [{
            name: response.data.name,
            type: 'area',
            color: color,
            fillColor: {
                linearGradient: {
                    x1: 0,
                    y1: 0,
                    x2: 0,
                    y2: 1
                },
                stops: [
                    [0, fillColor],
                    [1, Highcharts.Color(fillColor).setOpacity(0).get('rgba')]
                ]
            },
            threshold: null
        }]
    };

    var intraday = Highcharts.stockChart(optionsintraday);
    intraday.showLoading(LOADER_HTML);
    intraday.series[0].setData(response.history);
    intraday.hideLoading();
}
